export default function SvgAvatarDefault() {
  return (
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8337 12.8633C18.9289 12.8633 14.9556 16.8132 14.9556 21.6831C14.9556 26.553 18.9289 30.503 23.8337 30.503C28.7458 30.503 32.7118 26.553 32.7118 21.6831C32.7118 16.8132 28.7458 12.8633 23.8337 12.8633ZM23.8337 28.5462C20.0205 28.5462 16.935 25.4724 16.935 21.6831C16.935 17.8938 20.0277 14.8273 23.8337 14.8273C27.6542 14.8273 30.7397 17.8938 30.7397 21.6831C30.7397 25.4724 27.6542 28.5462 23.8337 28.5462Z"
        fill="white"
      />
      <path
        d="M32.304 33.4863H15.295C11.7794 33.4863 8.66886 35.0567 6.85077 37.4348C7.60041 38.2126 8.41898 38.9305 9.30648 39.596C10.8575 37.4348 13.6148 35.999 16.7339 35.999H30.8651C34.1394 35.999 37.0173 37.5844 38.5079 39.9176C39.4127 39.2745 40.2485 38.5715 41.0326 37.8162C39.2576 35.2287 36.0005 33.4863 32.304 33.4863Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 47C36.4787 47 47 36.4787 47 23.5C47 10.5213 36.4787 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4787 10.5213 47 23.5 47ZM23.5007 45.0413C35.3978 45.0413 45.0424 35.3968 45.0424 23.4996C45.0424 11.6025 35.3978 1.95795 23.5007 1.95795C11.6036 1.95795 1.95904 11.6025 1.95904 23.4996C1.95904 35.3968 11.6036 45.0413 23.5007 45.0413Z"
        fill="#D9D9D9"
      />
    </svg>
  );
}
